import React, { useState, useEffect } from 'react'
import { MuiThemeProvider, makeStyles, useTheme } from '@material-ui/core/styles'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Typography, Button, MenuItem, TextField, InputAdornment, Tooltip, IconButton, Icon } from '@material-ui/core'

import { AddOutlined, Search, Close, FilterList } from '@material-ui/icons'

import MaterialTable, { MTableCell } from '@material-table/core'
import { table } from '../../services/theme'
import clsx from 'clsx'
import { getHouseholdById } from '../../actions/households/households.actions'
import useMarkets from '../../hooks/useMarkets'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		},
		marginLeft: 16
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '24px 25px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	searchField: {
		minWidth: 150,
		paddingLeft: theme.spacing(2)
	},
	searchBy: {
		minWidth: 150,
		paddingLeft: theme.spacing(2),
		'& label': {
			transform: 'translate(28px, 14px) scale(1)'
		},
		'& svg': {
			top: 'calc(50% - 14px)',
			marginLeft: 23
		}
	},
	select: {
		paddingRight: '50px !important'
	}
}))

export const ClientsTable = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()
	const params = useParams()
	const dispatch = useDispatch()
	const householdsLoading = useSelector((state) => state.specific.households.loading)
	const facility = useSelector((state) => state.specific.facilities.selected)

	const [loading, setLoading] = useState(false)
	const [search, setSearch] = useState('')
	const [searchBy, setSearchBy] = useState('Contact')
	const [page, setPage] = useState(0)

	const { markets, marketIdToIndexMap } = useMarkets()

	useEffect(() => {
		if (householdsLoading) {
			setLoading(true)
		} else {
			setLoading(false)
		}
	}, [householdsLoading])

	const renderPets = (pets) => {
		return (
			<div>
				{pets.length > 0
					? pets
						.filter((pet) => pet.active)
						.map((pet) => (
							<div key={pet._id} style={{ display: 'flex', flexDirection: 'column' }}>
								<Typography style={{ color: '#6B4AD6' }}>{pet.name}</Typography>
							</div>
						))
					: null}
			</div>
		)
	}

	const goToClient = (household) => {
		dispatch(getHouseholdById(household._id)).then(() => {
			history.push(`/clients/${household._id}/appointments`)
		})
	}

	useEffect(() => {
		if (searchBy === 'Phone') {
			if (search?.length > 4) {
				props.onSearchChange(search.toLowerCase(), searchBy, page)
			}
		} else {
			if (searchBy && search && search.length > 2) {
				props.onSearchChange(search.toLowerCase(), searchBy, page)
			}
		}
	}, [search, searchBy, page])

	let options = ['Contact', 'Pet Name', 'Email', 'Phone']

	return (
		<MuiThemeProvider theme={table}>
			<div className={classes.toolbarWrapper}>
				<div className={classes.toolbar}>
					{/* <MTableToolbar
            {...props}
            searchBy={ true }
            searchByOptions={ options }
            searchFieldVariant="filled"
          /> */}
					<Typography
						variant="h6"
						style={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis'
						}}>
						Clients
					</Typography>
					<TextField
						select
						variant="filled"
						value={searchBy}
						label={!searchBy ? 'Search by' : null}
						onChange={(e) => setSearchBy(e.target.value)}
						className={classes.searchBy}
						InputLabelProps={{ shrink: false }}
						SelectProps={{
							renderValue: () => `Search by: ${searchBy}`,
							inputProps: { className: classes.select }
						}}>
						{options &&
							options.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
					</TextField>
					<TextField
						autoFocus={true}
						className={classes.searchField}
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						placeholder="Search"
						variant="filled"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Tooltip title="Search">
										<Search color="inherit" fontSize="small" />
									</Tooltip>
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment position="end">
									<IconButton disabled={!search} onClick={() => setSearch('')}>
										<Close color="inherit" fontSize="small" />
									</IconButton>
								</InputAdornment>
							),
							inputProps: {
								'aria-label': 'Search'
							}
						}}
					/>
					<Button
						variant="outlined"
						className={clsx(classes.headerButton, classes.addClientButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						size="large"
						onClick={() => history.push(`/clients/create`)}>
						Client
					</Button>
				</div>
			</div>
			<MaterialTable
				isLoading={loading}
				icons={{
					Search: () => <FilterList fontSize="small" style={{ color: '#777679' }} />
				}}
				localization={{ toolbar: { searchPlaceholder: 'Filter' } }}
				onPageChange={(norp, page) => {
					console.log('the page...', norp, page)
				}}
				options={{
					showTitle: false,
					toolbar: true,
					searchFieldAlignment: 'right',
					search: true,
					searchFieldVariant: 'outlined',
					searchFieldStyle: {
						height: '40px',
						paddingRight: 0
					},
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2'
					},
					pageSize: 20,
					pageSizeOptions: [20],
					toolbarButtonAlignment: 'left'
				}}
				columns={[
					{
						title: 'Client',
						field: 'account.full_name',
						cellStyle: {
							color: '#6B4AD6',
							fontWeight: 800
						}
					},
					{ title: 'Email', field: 'account.email' },
					{ title: 'Prim Phone', field: 'account.phone_number' },
					{
						title: 'Pet(s)',
						field: 'pets',
						render: (data) => renderPets(data.pets)
					},
					{
						title: 'Market',
						render: (data) => {
							if (!data.market_id) {
								return 'Not Set'
							}
							const clientMarket = markets[marketIdToIndexMap[data.market_id]]
							return clientMarket?.city || 'Not Set'
						},
						customSort: (a, b) => {
							let aMarket = markets[marketIdToIndexMap[a.market_id]]
							let bMarket = markets[marketIdToIndexMap[b.market_id]]
							return aMarket?.city.localeCompare(bMarket?.city)
						},
						customFilterAndSearch: (value, data) => {
							if (!value) {
								return true
							}
							const clientMarket = markets[marketIdToIndexMap[data.market_id]]
							return clientMarket?.city?.toLowerCase().includes(value.toLowerCase())
						}
					},
					{ title: 'FOR SEARCH ONLY (HIDDEN)', field: 'searchable_pets', searchable: true, hidden: true }
				]}
				data={props.households || []}
				onRowClick={(e, household) => goToClient(household)}
				components={{
					Cell: (props) => (
						<MTableCell
							style={{
								fontSize: '16px',
								lineHeight: '22px',
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					),
					Pagination: (pag_props) => {
						return (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'flex-end',
									padding: '8px 24px'
								}}>
								<IconButton onClick={() => setPage(page - 1)} disabled={page === 0}>
									<Icon className="fa fa-chevron-left" style={{ fontSize: 14 }}></Icon>
								</IconButton>
								<IconButton onClick={() => setPage(page + 1)} disabled={!props?.households?.length || props?.households?.length < 20}>
									<Icon className="fa fa-chevron-right" style={{ fontSize: 14 }}></Icon>
								</IconButton>
							</div>
						)
					}
				}}
				title="Clients"
			/>
		</MuiThemeProvider>
	)
}
